import { render, staticRenderFns } from "./dhPopup.vue?vue&type=template&id=60ae67a6&scoped=true"
import script from "./dhPopup.vue?vue&type=script&lang=js"
export * from "./dhPopup.vue?vue&type=script&lang=js"
import style0 from "./dhPopup.vue?vue&type=style&index=0&id=60ae67a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ae67a6",
  null
  
)

export default component.exports